import { connectToStores } from 'fluxible-addons-react';
import OnlineStatusStore from 'contest/stores/online-status-store';
import StatusIndicator from '../status-indicator';

// Connect to the store that provides the data
export default connectToStores(StatusIndicator, [OnlineStatusStore], (context, props) => {
    return {
        isOnline: context.getStore(OnlineStatusStore).getOnlineStatus(props.user.userId),
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-status-indicator.jsx